export const PR_PATH =
  '/:repositoryOwner/:repositorySlug/pull-requests/:pullRequestId/:tab(overview|diff|commits)?';
export const buttonAppearance = (
  isStickyHeader: boolean
): 'subtle-link' | 'default' => (isStickyHeader ? 'subtle-link' : 'default');
export const buttonSpacing = (isStickyHeader: boolean): 'compact' | 'default' =>
  isStickyHeader ? 'compact' : 'default';
